import React from 'react';
import AssetsContainer from './AssetsContainer';

const AssetsView = () => {
  return <AssetsContainer />;
};

export default AssetsView;
